// extracted by css-extract-rspack-plugin
export default {"setka":"setka--BbzvflQzq2oBc3eD"};